export default __webpack_public_path__ + "static/media/img-0788-portugal-half-face.f280ed84.png";